import React from "react";

const MessagesPage = function () {
  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h2 className="mb-5">Messages</h2>
          <p className="lead">This feature is coming soon</p>
        </div>
      </div>
    </div>
  );
};

export default MessagesPage;
